var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useReducer, useEffect } from 'react';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
import { WizardContext } from '@data-driven-forms/react-form-renderer/dist/cjs';
import get from "lodash/get";
import set from "lodash/set";
import flattenDeep from "lodash/flattenDeep";
import { handleEnter } from './enter-handler';
import reducer, { DYNAMIC_WIZARD_TYPES, findCurrentStep } from './reducer';
import { selectNext } from './select-next';
import values from "lodash/values";
;
export var WizardBase = function (_a) {
    var _b = _a.fields, fields = _b === void 0 ? [] : _b, isDynamic = _a.isDynamic, crossroads = _a.crossroads, Wizard = _a.Wizard, component = _a.component, initialState = _a.initialState, props = __rest(_a, ["fields", "isDynamic", "crossroads", "Wizard", "component", "initialState"]);
    var formOptions = useFormApi();
    var _c = useReducer(reducer, __assign(__assign({ activeStep: get(fields, 0, { name: "" }).name, prevSteps: [], activeStepIndex: 0, maxStepIndex: 0 }, initialState), { isDynamic: isDynamic || fields.some(function (_a) {
            var nextStep = _a.nextStep;
            return DYNAMIC_WIZARD_TYPES.includes(typeof nextStep);
        }), loading: true })), state = _c[0], dispatch = _c[1];
    useEffect(function () {
        dispatch({ type: 'finishLoading', payload: { formOptions: formOptions, fields: fields } });
    }, [fields]);
    if (state.loading) {
        return null;
    }
    var prepareValues = function (theValues, visitedSteps, getRegisteredFields) {
        var _a;
        // Add the final step fields to history
        var finalRegisteredFieldsHistory = __assign(__assign({}, state.registeredFieldsHistory), (_a = {}, _a[state.activeStep] = getRegisteredFields(), _a));
        var finalObject = {};
        // Find only visited fields
        flattenDeep(values(__spreadArray(__spreadArray([], visitedSteps), [state.activeStep]).reduce(function (obj, key) {
            var _a;
            return (__assign(__assign({}, obj), (_a = {}, _a[key] = finalRegisteredFieldsHistory[key], _a)));
        }, {}))).forEach(function (key) { return set(finalObject, key, get(theValues, key)); });
        return finalObject;
    };
    var onCancel = function () { return formOptions.onCancel && formOptions.onCancel(state); };
    var handleSubmit = function () {
        return formOptions["onSubmit"](prepareValues(formOptions.getState().values, __spreadArray(__spreadArray([], state.prevSteps), [state.activeStep]), formOptions.getRegisteredFields), formOptions, state);
    };
    var jumpToStep = function (index, valid) { return dispatch({ type: 'jumpToStep', payload: { index: index, valid: valid, fields: fields, crossroads: crossroads, formOptions: formOptions } }); };
    var handlePrev = function () { return jumpToStep(state.activeStepIndex - 1); };
    var handleNext = function (nextStep) { return dispatch({ type: 'handleNext', payload: { nextStep: nextStep, formOptions: formOptions, fields: fields } }); };
    var setPrevSteps = function () { return dispatch({ type: 'setPrevSteps', payload: { formOptions: formOptions, fields: fields } }); };
    var findCurrentStepWrapped = function (step) { return findCurrentStep(step, fields); };
    var onKeyDown = function (e) { return handleEnter(e, formOptions, state.activeStep, findCurrentStepWrapped, handleNext, handleSubmit); };
    var wizardContext = {
        handleNext: handleNext,
        onKeyDown: onKeyDown,
        setPrevSteps: setPrevSteps,
        currentStep: findCurrentStep(state.activeStep, fields),
        jumpToStep: jumpToStep,
        handlePrev: handlePrev,
        formOptions: __assign(__assign({}, formOptions), { onCancel: onCancel,
            handleSubmit: handleSubmit }),
        fields: fields,
        navSchema: state.navSchema,
        activeStepIndex: state.activeStepIndex,
        maxStepIndex: state.maxStepIndex,
        isDynamic: state.isDynamic,
        crossroads: crossroads,
        prevSteps: state.prevSteps,
        selectNext: selectNext
    };
    return (React.createElement(WizardContext.Provider, { value: wizardContext },
        React.createElement(Wizard, __assign({}, props))));
};
